module.exports = __webpack_public_path__ + "img/date-1.4ee4bb93.svg";